import { Api } from '../generated-api-types-document/Api'

export type AuthToken = string

// Nest klient pre /document doc (download PDF dokumentov z portfólia).
class ApiClientDocument {
  apiInstance: Api<AuthToken>

  constructor() {
    this.apiInstance = new Api<AuthToken>({
      baseUrl: `${import.meta.env.VITE_REACT_API2_HOST}`,
      baseApiParams: {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
      },
      securityWorker: (token: AuthToken | null) => {
        return token
          ? {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          : {}
      },
    })
  }

  setAuthToken(newToken: string | null) {
    this.apiInstance.setSecurityData(newToken ? newToken : null)
  }
}

export default ApiClientDocument
